// Where the account side is (docs/features/site-split.md): the app runs on app.codymccodeface.com (or staging, or
// a local worker) and holds no account; the website, sign-in, the board and invites are on www. Only the public
// board is read from here (CORS, no cookie); anything about a person is done on www itself. Staging is the one
// exception: facecheck.codymccodeface.com is the site and the app on one hostname (its own invites and
// database), so there the account side is this same origin.
//
// One seam: `wwwOrigin()`.
export function wwwOrigin() {
  const host = location.hostname
  if (host === 'localhost' || host === '127.0.0.1' || host === '[::1]' || host.endsWith('.localhost')) return 'http://127.0.0.1:8789'   // services/www `npm run dev`
  if (host === 'facecheck.codymccodeface.com') return location.origin
  return 'https://www.codymccodeface.com'
}
